import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/vendors/login/Page";

export const PATH = "/vendors/login";

const Login: NextPage = () => (
	<>
		<NskHead title="TOP" />
		<Component />
	</>
);

export default Login;
